import { motion } from 'framer-motion';
import { Box } from '@chakra-ui/react';

const MotionBox = motion(Box);

/**
 * Simple fade in animation
 */
export function FadeIn({
  children,
  duration = 0.4,
  delay = 0,
  ...props
}) {
  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration,
        delay,
        ease: [0.4, 0, 0.2, 1],
      }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}

/**
 * Slide in animation from any direction
 */
export function SlideIn({
  children,
  direction = 'up',
  duration = 0.4,
  delay = 0,
  distance = 20,
  ...props
}) {
  const directions = {
    up: { y: distance },
    down: { y: -distance },
    left: { x: distance },
    right: { x: -distance },
  };

  return (
    <MotionBox
      initial={{
        opacity: 0,
        ...directions[direction],
      }}
      animate={{
        opacity: 1,
        x: 0,
        y: 0,
      }}
      transition={{
        duration,
        delay,
        ease: [0.4, 0, 0.2, 1],
      }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}

/**
 * Scale in animation
 */
export function ScaleIn({
  children,
  duration = 0.4,
  delay = 0,
  initialScale = 0.9,
  ...props
}) {
  return (
    <MotionBox
      initial={{
        opacity: 0,
        scale: initialScale,
      }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
      transition={{
        duration,
        delay,
        ease: [0.175, 0.885, 0.32, 1.275], // Spring easing
      }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}
